import axiosInstance from './axiosInstance';

/**
 * 上传图片
 * @param {FormData} formData - 包含图片文件的FormData对象
 * @returns {Promise<Object>} - 包含上传结果的Promise
 */
export const uploadImage = (formData) => {
  return axiosInstance.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(response => {
    // 确保返回的数据结构正确
    if (!response.data.src || !response.data.storagePath) {
      throw new Error('上传成功但返回数据结构不正确');
    }
    return response.data;
  }).catch(error => {
    console.error('上传API错误:', error);
    // 提取错误信息
    const errorMessage = error.response?.data?.error || error.message || '上传失败';
    throw new Error(errorMessage);
  });
};